import React from "react";
import { Box, Typography } from "@mui/material";
import { RetirementSavingsByAge } from "../../../interfaces/DTO/mislaka_xml_pension_models";
import {
  formatGuaranteedConversionFactor,
  formatLifeExpectancyImpact,
  formatYieldImpact,
} from "../../../utils/enumFormatter";
import { formatCurrency, formatPercentage } from "../../../utils/namesFormater";
import { DataRowsDisplay } from "../../../shared/UIParts/DataRowsDisplay";


interface Props {
  data?: RetirementSavingsByAge[];
}

const RetirementSavingsByAgeCards: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <Box dir="rtl" display="flex" flexDirection="column" gap={3}>
    
      {data.map((row, index) => {
        const rows = [
          { label: "גיל פרישה", value: row.retirement_age?.toString() },
          { label: "סה\"כ חיסכון כולל פרמיות", value: formatCurrency(row.total_expected_savings_with_premiums) },
          { label: "חיסכון צפוי ללא פרמיות", value: formatCurrency(row.projected_savings_without_premiums) },
          { label: "מקדם מובטח לפרישה", value: row.guaranteed_conversion_factor?.toString() },
          { label: "קיים מקדם המרה הכולל הבטחת תוחלת חיים", value: formatGuaranteedConversionFactor(row.life_expectancy_guaranteed) },
          { label: "הבטחת תוחלת חיים מותנית במסלול פרישה", value: formatGuaranteedConversionFactor(row.conditional_life_expectancy_guarantee) },
          { label: "מקדם תשואה מובטח", value: formatGuaranteedConversionFactor(row.guaranteed_yield_conversion_factor) },
          { label: "מקדם ההמרה המגלם הבטחת תשואה מוגבל בתקופה", value: formatGuaranteedConversionFactor(row.yield_conversion_period_limited) },
          { label: "שנות הגבלה", value: row.restriction_period_years?.toString() },
          { label: "שינויים בתוחלת החיים משפיעים על עדכון קצבה", value: formatLifeExpectancyImpact(row.life_expectancy_changes_affect_pension) },
          { label: "שינויים בתשואה משפיעים על עדכון קצבה", value: formatYieldImpact(row.yield_changes_affect_pension) },
          { label: "שיעור פנסיית זקנה צפויה", value: formatPercentage(row.expected_retirement_pension_rate) },
        ];

        const title = row.plan_name?.trim() || "מסלול לא ידוע";

        return (
          <DataRowsDisplay
            key={index}
            title={title}
            rows={rows}
            maxWidth={800}
          />
        );
      })}
    </Box>
  );
};

export default RetirementSavingsByAgeCards;